import { Button, Icon, IconTypes, IconColor, TourWelcomeModal } from '@app/ui'
import { ButtonType } from '@app/types'
import { Trans, useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

type CompletionModalProps = {
  onComplete: () => void
}

const completionPoints = [
  { msg: 'tips.step.sub1', icon: '✨' },
  { msg: 'tips.step.sub2', icon: '🧩' },
  { msg: 'tips.step.sub3', icon: '🪄' },
  { msg: 'tips.step.sub4', icon: '📊' },
]

export const CompletionModal = ({ onComplete }: CompletionModalProps) => {
  const { t } = useTranslation()

  return (
    <TourWelcomeModal
      title={t('tips.step.start')}
      sub={t('tips.step.startsub')}
      open={true}
      zIndex={11}
      centered={true}
      padding="26px"
      icon="🎉"
      styleExtender={CompletionStyles}
    >
      <>
        <MainTitle>{t('tips.step.title')}</MainTitle>

        <PointsList>
          {completionPoints.map(({ msg, icon }, key) => (
            <PointItem key={key}>
              <PointIcon>{icon}</PointIcon>
              <PointText><Trans i18nKey={msg} /></PointText>
            </PointItem>
          ))}
        </PointsList>

        <CTAText>{t('tips.step.cta')}</CTAText>

        <ActionButton
          type={ButtonType.primary}
          className="vb-font w500 small white"
          borderRadius="59px"
          onClick={onComplete}
        >
          <span className="button-text">{t('onboarding.enterApplication')}</span>
          <span className="button-icon">
            <Icon
              type={IconTypes.arrowRight}
              color={IconColor.white}
              width={16}
              height={16}
            />
          </span>
        </ActionButton>
      </>
    </TourWelcomeModal>
  )
}

const CompletionStyles = css`
  .content {
    padding: 24px 16px;
  }
`

const MainTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #2B2D30;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.4;
  width: 100%;
`

const PointsList = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
`

const PointItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`

const PointIcon = styled.span`
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
`

const PointText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #2B2D30;
  line-height: 1.5;
  margin: 0;
  flex: 1;
  
  span {
    font-weight: 700;
  }
`

const CTAText = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #48C0AE;
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`

const ActionButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .button-text {
    font-size: 14px;
    font-weight: 500;
  }
  
  .button-icon {
    display: inline-flex;
    align-items: center;
  }
`